import { render, staticRenderFns } from "./SearchProductsReport.vue?vue&type=template&id=2c4b2730&scoped=true&lang=html"
import script from "./SearchProductsReport.vue?vue&type=script&lang=js"
export * from "./SearchProductsReport.vue?vue&type=script&lang=js"
import style0 from "./SearchProductsReport.vue?vue&type=style&index=0&id=2c4b2730&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4b2730",
  null
  
)

export default component.exports